module.exports = __webpack_public_path__ + "static/hero-complete-package-00852a339f366f3de8ab6472f8ac9615.jpg";